module.exports = __webpack_public_path__ + "static/media/kitchen-trash-icon.050c839a.png";